import {
    EModalId,
    type ModalApontamentoCadastro,
    type ModalApontamentoLista, type ModalAutorizacaoCodigo,
    type ModalEmptyComponent, type ModalGrupoPermissaoCadastro
} from "@/domain/type/modal.type";

import {useDialog} from "primevue/usedialog";
import {useModalStore} from "@/stores/modal.store";
import EmptyComponent from "@/components/EmptyComponent.vue";
import ApontamentoLista from "@/components/apontamentos/ApontamentoLista.vue";
import ApontamentoCadastro from "@/components/apontamentos/ApontamentoCadastro.vue";
import GrupoPermissaoCadastro from "@/components/grupoPermissao/GrupoPermissaoCadastro.vue";
import {useAuthStore} from "@/stores/auth.store";
import AutorizacaoAcaoCodigo from "@/components/autorizacao/AutorizacaoAcaoCodigo.vue";
import {EAutorizacaoAcaoTipo, type ResultadoCodigoAutorizacao} from "@/domain/type/autorizacao.type";


export const useModalHelper = () => {

    const dialog = useDialog();
    const modalStore = useModalStore();
    const cgpe = useAuthStore().getUserCgpe();


    const visualizarObservacaoModal = (titulo: string, conteudo: string) => {

        if (!conteudo || conteudo.trim() == "") return;

        const modal = modalStore.getModal(EModalId.modalEmptyComponent);
        const params: ModalEmptyComponent = {
            content: conteudo
        }

        modal?.setParam(params);

        dialog.open(EmptyComponent,
            {
                props: {
                    header: titulo,
                    style: {
                        width: '40vw',
                    },
                    breakpoints: {
                        '1199px': '30vw',
                        '575px': '90vw'
                    },
                    modal: true,

                }
            }
        );
    }

    const visualizarApontamentoModal = (service: any, events: any, codigoEntidade: string, titulo: string) => {

        //Valida as informacoes para carregar o modal de apontamentos
        if (!service || !service.apontamentoService) return;
        if (!events || !events.apontamentoEvent) return;
        if (!codigoEntidade || codigoEntidade == "") return;

        const modal = modalStore.getModal(EModalId.modalApontamentoLista);

        if (!modal) return;

        const params: ModalApontamentoLista = {
            entidadeService: service.apontamentoService,
            codigoEntidade: codigoEntidade,
            apontamentoEvent: events.apontamentoEvent,
        }

        modal.setParam(params);

        //Abre o modal com os apontamentos
        dialog.open(ApontamentoLista, {
            props: {

                header: titulo,
                style: {
                    width: '80vw',
                },
                breakpoints: {
                    '1199px': '80vw',
                    '575px': '90vw'
                },
                modal: true,
                closeOnEscape: false

            },

        });

    }

    const adicionarApontamentoModal = (service: any, events: any, codigoEntidade: string, titulo: string) => {

        //Valida as informacoes para carregar o modal de apontamentos
        if (!service || !service.apontamentoService) return;
        if (!events || !events.apontamentoEvent) return;
        if (!codigoEntidade || codigoEntidade == "") return;
        const modal = modalStore.getModal(EModalId.modalApontamentoCadastro);

        if (!modal) return;

        const params: ModalApontamentoCadastro = {
            entidadeService: service.apontamentoService,
            codigoEntidade: codigoEntidade,
            apontamentoEvent: events.apontamentoEvent,
        }

        modal.setParam(params);

        dialog.open(ApontamentoCadastro, {
            props: {

                header: titulo,
                style: {
                    width: '50vw',
                },
                breakpoints: {
                    '1199px': '75vw',
                    '575px': '90vw'
                },
                modal: true,
                closeOnEscape: false
            },

        });

    }

    const visualizarGrupoPermissao = (codigoGrupoPermissao: number) => {


        const modal = modalStore.getModal(EModalId.modalGrupoPermissaoCadastro);

        if (!modal) return;

        const params: ModalGrupoPermissaoCadastro = {
            propCgpe: cgpe,
            propCodigoGrupoPermissao: codigoGrupoPermissao,
            propIsVisualizacao: true
        }

        modal.setParam(params);

        //Abre o modal de cadastro do grupo de permissão
        dialog.open(GrupoPermissaoCadastro, {
            props: {

                header: 'Grupo de Permissão',
                style: {
                    width: '35vw',
                },
                breakpoints: {
                    '1199px': '70vw',
                    '575px': '90vw'
                },
                modal: true,
                closeOnEscape: false
            },

        });
    }

    const solicitarCodigoAutorizacao = (modalParams: ModalAutorizacaoCodigo) => new Promise((resolve, reject) => {

        const modal = modalStore.getModal(EModalId.modalAutorizacaoCodigo);

        modal?.setParam(modalParams);

        let tituloModal = "";

        //ajusta o titulo conforme o tipo
        if (modalParams.propTipoAutorizacao == EAutorizacaoAcaoTipo.DescontoNoProduto) {
            tituloModal = "Autorização de Desconto"
        } else if (modalParams.propTipoAutorizacao == EAutorizacaoAcaoTipo.CancelamentoVenda) {
            tituloModal = "Autorização de Cancelamento de Venda"
        }


        dialog.open(AutorizacaoAcaoCodigo, {
            props: {

                header: tituloModal,
                style: {
                    width: '40vw',
                },
                breakpoints: {
                    '1199px': '60vw',
                    '700px': '95vw'
                },
                modal: true,

            },
            onClose(options) {
                if (options?.data?.resultadoAutorizacao) {
                    const retorno = (options?.data?.resultadoAutorizacao as ResultadoCodigoAutorizacao);

                    if (retorno.resultado) {
                        resolve(retorno);
                    } else {
                        reject(false);
                    }

                } else {
                    reject(false);
                }
            },

        });


    })

    return {
        visualizarObservacaoModal,
        visualizarApontamentoModal,
        adicionarApontamentoModal,
        visualizarGrupoPermissao,
        solicitarCodigoAutorizacao
    };
}